module.exports = {
      id: "ic-rate-of-change-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-rate-of-change-usage",
      toString: function () {
        return this.url;
      }
    }